import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, StaticImage, getImage } from 'gatsby-plugin-image';
import { CustomPopover } from '../../../cs/common/components/custom-popover';
import { INikkeCharacterNode } from '../../../common/model/graphql-types';
import { NikkeCharacterPopover } from './nikke-popover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faHorseHead } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  employee: INikkeCharacterNode;
  enablePopover?: boolean;
  showLabel?: boolean;
  showTags?: boolean;
  showIcon?: boolean;
  showBug?: boolean;
  showStatus?: boolean;
}

export const NikkeCharacterCard: React.FC<IProps> = ({
  employee,
  showLabel,
  enablePopover,
  showTags,
  showIcon,
  showStatus
}) => {
  const image = employee.cardImage
    ? getImage(employee.cardImage.localFile.childImageSharp)
    : null;
  return (
    <CustomPopover
      enabled={enablePopover}
      customClass="character-hover-box nikke"
      popover={<NikkeCharacterPopover character={employee} />}
    >
      <Link to={'/nikke/characters/' + employee.slug}>
        <div
          className={`avatar nikke-card rarity-${employee.rarity} ${
            employee.hasTreasure ? 'has-treasure' : ''
          } ${showLabel ? showLabel : ''}`}
        >
          <div className="overlay"></div>
          {image && (
            <GatsbyImage
              className="disable-transition"
              image={image}
              alt={`${employee.name}`}
            />
          )}
          {showLabel && <span className="emp-name">{employee.name}</span>}
          {showIcon && (
            <span className="floating-element nikke">
              {employee.slug === 'red-hood' ? (
                <>
                  <StaticImage
                    src="../../../../images/nikke/icons/type_all_bg.png"
                    alt="Type All"
                  />
                </>
              ) : (
                <>
                  {employee.burstType === '1' && (
                    <StaticImage
                      src="../../../../images/nikke/icons/type_1_bg.png"
                      alt={employee.burstType}
                    />
                  )}
                  {employee.burstType === '2' && (
                    <StaticImage
                      src="../../../../images/nikke/icons/type_2_bg.png"
                      alt={employee.burstType}
                    />
                  )}
                  {employee.burstType === '3' && (
                    <StaticImage
                      src="../../../../images/nikke/icons/type_3_bg.png"
                      alt={employee.burstType}
                    />
                  )}
                </>
              )}
            </span>
          )}
          {showIcon && (
            <span className="floating-element nikke element">
              <>
                {employee.element === 'Wind' && (
                  <StaticImage
                    src="../../../../images/nikke/icons/wind_bg.png"
                    alt="Wind"
                  />
                )}
                {employee.element === 'Water' && (
                  <StaticImage
                    src="../../../../images/nikke/icons/water_bg.png"
                    alt="Water"
                  />
                )}
                {employee.element === 'Electric' && (
                  <StaticImage
                    src="../../../../images/nikke/icons/ele_bg.png"
                    alt="WElectric"
                  />
                )}
                {employee.element === 'Iron' && (
                  <StaticImage
                    src="../../../../images/nikke/icons/iron_bg.png"
                    alt="Iron"
                  />
                )}
                {employee.element === 'Fire' && (
                  <StaticImage
                    src="../../../../images/nikke/icons/fire_bg.png"
                    alt="Fire"
                  />
                )}
              </>
            </span>
          )}
        </div>
        {showLabel && employee.isNew && showTags && (
          <span className="tag new">New</span>
        )}
        {showLabel && employee.isLimited && showStatus && (
          <>
            {employee.highInvestement ? (
              <>
                <span className="tag limited with-inv">
                  <FontAwesomeIcon icon={faClock} width="18" />
                </span>
              </>
            ) : (
              <>
                {employee.isNew ? (
                  <>
                    <span className="tag limited with-new">
                      <FontAwesomeIcon icon={faClock} width="18" />
                    </span>
                  </>
                ) : (
                  <>
                    <span className="tag limited">
                      <FontAwesomeIcon icon={faClock} width="18" />
                    </span>
                  </>
                )}
              </>
            )}
          </>
        )}
        {showStatus && employee.highInvestement && (
          <span className="tag invest">$</span>
        )}
        {showStatus && employee.hasTreasure && (
          <>
            {employee.isNew ? (
              <>
                <span className="tag treasure with-new">
                  <FontAwesomeIcon icon={faHorseHead} width="18" />
                </span>
              </>
            ) : (
              <>
                <span className="tag treasure">
                  <FontAwesomeIcon icon={faHorseHead} width="18" />
                </span>
              </>
            )}
          </>
        )}
      </Link>
    </CustomPopover>
  );
};
